var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionTasks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C12.3137 15 15 12.3137 15 9C15 8.00265 14.7566 7.06208 14.326 6.23453L8.25 12.3106L4.71964 8.78032L5.78029 7.7196L8.25 10.1893L13.4566 4.98265L13.4561 4.98205L14.5179 3.92026C15.7484 5.2563 16.5 7.04039 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C10.6415 1.5 12.1599 2.02736 13.3948 2.92192L12.3172 3.99961C11.367 3.368 10.2265 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionTasks);
export default __webpack_public_path__ + "static/media/attentionTasks.841973f3698aba67c73802402ba4a17e.svg";
export { ForwardRef as ReactComponent };